import React, { useState, useEffect } from 'react';
import {CookieIcon} from '../../svgs/EvironemtIcon';
import axios from 'axios';
import './cookie-banner.scss';

const checkConsentStatus = async (setVisible, activateScriptsByConsent) => {
    try {
        const response = await axios.get('/api/cookie-consent-status', {
            withCredentials: true
        });
        const data = response.data;  // ✅ CORRETTO: axios già parsa la risposta
        
        if (data.success && data.data) {
            setVisible(data.data.needsBanner);
            
            if (!data.data.needsBanner && data.data.categories) {
                activateScriptsByConsent(data.data.categories);
            }
        } else {
            setVisible(true);
        }
    } catch (error) {
        console.error('Errore verifica consenso:', error);
        setVisible(true);
    }
};

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        checkConsentStatus(setVisible, activateScriptsByConsent);
    }, []);

    // 🔥 Funzione che attiva gli script in base al consenso
    const activateScriptsByConsent = (categories) => {
        console.log('🔄 Attivazione script per categorie:', categories);
        
        // Google Analytics (esempio)
        if (categories.statistics && window.gtag) {
            window.gtag('consent', 'update', {
                analytics_storage: 'granted'
            });
            console.log('✅ Google Analytics attivato');
        }
        
        // Facebook Pixel (esempio)
        if (categories.marketing && window.fbq) {
            window.fbq('consent', 'grant');
            console.log('✅ Facebook Pixel attivato');
        }
        
        // Attiva script differiti con data-cookie-category
        document.querySelectorAll('[data-cookie-category]').forEach(script => {
            const scriptCategory = script.getAttribute('data-cookie-category');
            if (categories[scriptCategory]) {
                const newScript = document.createElement('script');
                if (script.src) {
                    newScript.src = script.src;
                }
                newScript.textContent = script.textContent;
                script.parentNode.replaceChild(newScript, script);
                console.log(`✅ Script ${scriptCategory} attivato`);
            }
        });
        
        // Dispatch evento personalizzato per altri componenti
        window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { 
            detail: categories 
        }));
    };

    const saveConsent = async (categories) => {
        setLoading(true);
        try {
            const response = await axios.post('/api/cookie-consent', { categories }, {
                withCredentials: true
            });
            
            if (response.data.success) {  // ✅ CORRETTO
                setVisible(false);
                // 🔥 Attiva gli script senza ricaricare
                activateScriptsByConsent(categories);
                
                // Mostra toast di conferma (opzionale)
                if (window.showToast) {
                    window.showToast('✅ Preferenze cookie salvate', 'success', 3000);
                }
            }
        } catch (error) {
            console.error('Errore salvataggio consenso:', error);
        } finally {
            setLoading(false);
        }
    };

    const acceptAll = () => {
        saveConsent({
            preferences: true,
            statistics: true,
            marketing: true
        });
    };

    const rejectAll = () => {
        saveConsent({
            preferences: false,
            statistics: false,
            marketing: false
        });
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner-compact">
            <div className="cookie-banner-compact__content">
                <div className="cookie-banner-compact__text">
                    <span className="cookie-icon"><CookieIcon className="cookie-icon"/></span>
                    <p>
                        Utilizziamo cookie tecnici essenziali e, con il tuo consenso,
                        anche cookie statistici e di marketing per migliorare la tua esperienza.
                    </p>
                </div>
                <div className="cookie-banner-compact__actions">
                    <button 
                        className="btn-link"
                        onClick={() => {
                            window.dispatchEvent(new CustomEvent('openCookiePreferences'));
                            setVisible(false);
                        }}
                    >
                        Personalizza
                    </button>
                    <button 
                        className="btn-secondary"
                        onClick={rejectAll}
                        disabled={loading}
                    >
                        {loading ? '...' : 'Rifiuta'}
                    </button>
                    <button 
                        className="btn-primary"
                        onClick={acceptAll}
                        disabled={loading}
                    >
                        {loading ? '...' : 'Accetta'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;